import { Inject, Injectable } from "@angular/core"
import { EnvironmentConfig, ENV_CONFIG } from "src/environments/environment.model";

@Injectable({ providedIn: 'root' })
export class Logger {
  constructor(@Inject(ENV_CONFIG) public config: EnvironmentConfig) {
    if (!this.config.logToConsole) console.log('%cProductSelector: logToConsole flag is off - Logging to the console has been disabled', 'color: goldenrod; padding: 2px');
  }

  public log: (...obj: any) => void = this.config.logToConsole ? console.log.bind(window.console, '%cLOG: ', 'color: #888888') : () => { };

  // log something as an error when an assertion fails
  public assert: (condition: boolean, ...obj: any) => void = this.config.logToConsole ? console.assert.bind(window.console) : () => { };

  // outputs the entire stack trace
  public trace: (...obj: any) => void = this.config.logToConsole ? console.trace.bind(window.console) : () => { };

  // count how many times a piece of code has executed.
  public count: (label?: string | undefined) => void = this.config.logToConsole ? console.count.bind(window.console) : () => { };

  // quick way to check the performance of your code, but should not be used for real benchmarking due to its low accuracy
  public time: (label?: string | undefined) => void = this.config.logToConsole ? console.time.bind(window.console) : () => { };
  public timeLog: (label?: string | undefined) => void = this.config.logToConsole ? console.timeLog.bind(window.console) : () => { };
  public timeEnd: (label?: string | undefined) => void = this.config.logToConsole ? console.timeEnd.bind(window.console) : () => { };

  public debug: (...obj: any) => void = this.config.logToConsole ? console.debug.bind(window.console, '%cDEBUG: ', 'color: #F0CC75') : () => { };
  public warn: (...obj: any) => void = this.config.logToConsole ? console.warn.bind(window.console, '%cWARN: ', 'color: #F0E363') : () => { };
  public error: (...obj: any) => void = this.config.logToConsole ? console.error.bind(window.console, '%cERROR: ', 'color: #F07580') : () => { };
}
